import {
  BlocksEditContainer,
  EditorUIProvider
} from "@pathwright/blocks-engine"
import { ContentEditor } from "../editor/ContentEditor"

const BlocksContentEditorContainer = (props) => {
  return (
    <BlocksEditContainer {...props}>
      <EditorUIProvider>
        <ContentEditor />
      </EditorUIProvider>
    </BlocksEditContainer>
  )
}

export default BlocksContentEditorContainer
